import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { Button } from "@progress/kendo-react-buttons";
// import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  emailValidator,
  MobileNoValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
// import ShadowCard from "../../components/common/ShadowCard";
// import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearBookingDetails } from "./bookingSlice";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { ITour, ITourDate } from "../tour/tourModel";
import {
  getAllGroupTours,
  getTourByID,
  getTourCostWithAddonsByID,
  getTourDatesByTourID,
} from "../tour/services/tour.services";
import { getAllActiveActivities } from "../activity/service/activity.services";
import moment from "moment";
import {
  formatIndianNumber,
  generateValueLabelRange,
} from "../../_helper/helper";
import FormTextField from "../../components/formFields/FormTextField";
import {
  createPaymentOrder,
  getBookingByNo,
  getPromoCodeDetails,
  saveTempTourBooking,
  saveTourBooking,
  updateTourBooking,
  verifyPayment,
} from "./services/booking.services";
import { ErrorToast } from "../../components/toast/Toasts";
import ShadowCard from "../../components/common/ShadowCard";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import IconComponent from "../../components/common/IconComponent";
import { RxCross2 } from "react-icons/rx";
import { FaCheckCircle } from "react-icons/fa";
import { IoPricetagsSharp } from "react-icons/io5";
import { useRazorpay } from "react-razorpay";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { RAZORPAY_KEY_ID } from "../../app/config";
import { clearTourCostAndAddonDetails } from "../tour/tourSlice";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormTextArea from "../../components/formFields/FormTextArea";

const PAYMENT_MODE = [
  { label: "Bank Transfer", value: "Razorpay" },
  { label: "Cash", value: "Cash" },
];
interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const TourChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const TourID = formRenderProps.valueGetter("TourID");

  useEffect(() => {
    if (TourID) {
      dispatch(getTourDatesByTourID(TourID));
      // dispatch(getTourAddonsByTourID(TourID));
      dispatch(getTourByID(TourID));
    }
  }, [TourID]);
  return null;
};
const DateChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const TourID = formRenderProps.valueGetter("TourID");
  const Date = formRenderProps.valueGetter("Date");
  const TourDateDetails = useAppSelector((state) => state.tour.TourDateDetails);
  const BookingDetails = useAppSelector(
    (state) => state.booking.BookingDetails,
  );
  const BookingNo = useAppSelector(
    (state) => state.booking.BookingDetails?.BookingNo,
  );

  useEffect(() => {
    if (Date && TourDateDetails && TourDateDetails?.length > 0) {
      const selectedDateDetails = TourDateDetails?.find(
        (e: any) => moment(e?.TourDate).format("YYYY-MM-DD") === Date,
      );

      const available_seat = selectedDateDetails?.AvailableSeat || 0;

      // Check if we're in edit mode and the selected TourID and Date match the original booking
      if (
        BookingNo &&
        TourID === BookingDetails?.TourID &&
        moment(Date).format("YYYY-MM-DD") ===
          moment(BookingDetails?.TravelDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      ) {
        // Get current form values for total participants
        const values = {
          SoloCount: formRenderProps.valueGetter("SoloCount") || "0",
          DualRiderCount: formRenderProps.valueGetter("DualRiderCount") || "0",
          BYOBCount: formRenderProps.valueGetter("BYOBCount") || "0",
          SICCount: formRenderProps.valueGetter("SICCount") || "0",
          ThreeCount: formRenderProps.valueGetter("ThreeCount") || "0",
          FourCount: formRenderProps.valueGetter("FourCount") || "0",
        };

        const totalBookings =
          +values.SoloCount +
          +values.DualRiderCount +
          +values.BYOBCount +
          +values.SICCount +
          +values.ThreeCount +
          +values.FourCount;

        // Calculate available seats as: Current Available Seat + Original Booking's TotalPax
        const adjustedAvailableSeat =
          (+available_seat || 0) + (+BookingDetails?.TotalPax || 0);

        formRenderProps.onChange("AvailableSeat", {
          value: adjustedAvailableSeat,
        });
        formRenderProps.onChange("RealAvailableSeat", {
          value: available_seat,
        });

        // Validate if current selection exceeds adjusted available seats
        if (totalBookings > adjustedAvailableSeat) {
          ErrorToast(
            `You cannot select more than ${adjustedAvailableSeat} seats!`,
          );
        }
      } else {
        // Normal mode - just show the available seat
        formRenderProps.onChange("AvailableSeat", {
          value: available_seat,
        });
        formRenderProps.onChange("RealAvailableSeat", {
          value: available_seat,
        });
      }
    } else {
      formRenderProps.onChange("AvailableSeat", {
        value: null,
      });
      formRenderProps.onChange("RealAvailableSeat", {
        value: null,
      });
    }
  }, [Date, TourDateDetails, BookingNo, BookingDetails, TourID]);

  // Also recalculate when participant counts change in edit mode
  useEffect(() => {
    if (
      BookingNo &&
      TourID === BookingDetails?.TourID &&
      Date === moment(BookingDetails?.TravelDate).format("YYYY-MM-DD") &&
      TourDateDetails
    ) {
      const selectedDateDetails = TourDateDetails?.find(
        (e: any) => moment(e?.TourDate).format("YYYY-MM-DD") === Date,
      );

      if (selectedDateDetails) {
        const available_seat = selectedDateDetails?.AvailableSeat || 0;
        const adjustedAvailableSeat =
          (+available_seat || 0) + (+BookingDetails?.TotalPax || 0);

        formRenderProps.onChange("AvailableSeat", {
          value: adjustedAvailableSeat,
        });
        formRenderProps.onChange("RealAvailableSeat", {
          value: available_seat,
        });
      }
    }
  }, [
    formRenderProps.valueGetter("SoloCount"),
    formRenderProps.valueGetter("DualRiderCount"),
    formRenderProps.valueGetter("BYOBCount"),
    formRenderProps.valueGetter("SICCount"),
    formRenderProps.valueGetter("ThreeCount"),
    formRenderProps.valueGetter("FourCount"),
    BookingNo,
    TourID,
    Date,
    BookingDetails,
    TourDateDetails,
  ]);

  const fetchCostAndAddons = async (TourID: number, Date: string) => {
    const payload = {
      TourID: TourID,
      TourDate: Date,
    };
    dispatch(getTourCostWithAddonsByID(payload));
  };

  useEffect(() => {
    if (Date && TourID) {
      fetchCostAndAddons(TourID, Date);
    } else {
      dispatch(clearTourCostAndAddonDetails());
    }
  }, [Date, TourID]);

  return null;
};
// const DateChangeWatcher: React.FC<ChangeWatcherProps> = ({
//   formRenderProps,
// }) => {
//   const dispatch = useAppDispatch();
//   const TourID = formRenderProps.valueGetter("TourID");
//   const Date = formRenderProps.valueGetter("Date");
//   const TourDateDetails = useAppSelector((state) => state.tour.TourDateDetails);

//   useEffect(() => {
//     if (Date && TourDateDetails && TourDateDetails?.length > 0) {
//       const available_seat = TourDateDetails?.find(
//         (e: any) => moment(e?.TourDate).format("YYYY-MM-DD") === Date,
//       )?.AvailableSeat;

//       formRenderProps.onChange("AvailableSeat", {
//         value: available_seat,
//       });
//     } else {
//       formRenderProps.onChange("AvailableSeat", {
//         value: null,
//       });
//     }
//   }, [Date, TourDateDetails]);

//   const fetchCostAndAddons = async (TourID: number, Date: string) => {
//     const payload = {
//       TourID: TourID,
//       TourDate: Date,
//     };
//     dispatch(getTourCostWithAddonsByID(payload));
//   };

//   useEffect(() => {
//     if (Date && TourID) {
//       fetchCostAndAddons(TourID, Date);
//     } else {
//       dispatch(clearTourCostAndAddonDetails());
//     }
//   }, [Date, TourID]);

//   return null;
// };

interface TotalBookingWatcherProps {
  formRenderProps: FormRenderProps;
  getAllFormValues: (formRenderProps: FormRenderProps) => any;
  calculateTotalPersons: (values: any) => any;
  setTotalBookings: any;
}
const TotalBookingWatcher: React.FC<TotalBookingWatcherProps> = ({
  formRenderProps,
  getAllFormValues,
  calculateTotalPersons,
  setTotalBookings,
}) => {
  const values = getAllFormValues(formRenderProps);

  useEffect(() => {
    const totalPersons = calculateTotalPersons(values);
    setTotalBookings(totalPersons.totalBookings);
  }, [values]);
  return null;
};

const CreateBooking: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const BookingNo = location.state?.BookingNo;
  const { Razorpay } = useRazorpay();

  const BookingDetails = useAppSelector(
    (state) => state.booking.BookingDetails,
  );
  const loading = useAppSelector((state) => state.booking.loading);
  const GroupToursList = useAppSelector((state) => state.tour.GroupToursList);
  const TourDateDetails = useAppSelector((state) => state.tour.TourDateDetails);
  const TourCostAndAddonDetails = useAppSelector(
    (state) => state.tour.TourCostAndAddonDetails,
  );
  // const TourDetails: any = useAppSelector((state) => state.tour.TourDetail);

  const [formKey, setFormKey] = React.useState(1);
  // const [selectedTourDate, setSelectedTourDate] = useState<any>(null);
  const [appliedPromo, setAppliedPromo] = useState<any>(null);
  const [appliedPromoAmount, setAppliedPromoAmount] = useState<number>(0);
  const [promoapplyLoading, setPromoapplyLoading] = useState<boolean>(false);
  const [expandedSections, setExpandedSections] = useState<
    Record<string, boolean>
  >({
    baseFare: false,
    discount: false,
  });
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [totalPayable, setTotalPayable] = useState<any>(0);
  const [minPaymentAmount, setMinPaymentAmount] = useState<any>(0);
  const [lastPayableAmount, setLastPayableAmount] = useState<any>(0);
  const [totalBookings, setTotalBookings] = useState<any>(0);

  const AdultOption = generateValueLabelRange(1, 20, "string");
  const AddonOption = generateValueLabelRange(1, 20, "string");

  useEffect(() => {
    if (BookingNo) {
      dispatch(getBookingByNo(BookingNo));
    }
    return () => {
      dispatch(clearBookingDetails());
      dispatch(clearTourCostAndAddonDetails());
    };
  }, [BookingNo]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [BookingDetails, BookingDetails?.Date]);

  useEffect(() => {
    const filter = {
      TourName: "",
      PageSize: 200,
      PageIndex: 1,
    };
    dispatch(getAllGroupTours(filter));
    dispatch(getAllActiveActivities());
  }, []);

  useEffect(() => {
    if (BookingNo && BookingDetails?.CouponCode) {
      setAppliedPromo({
        CouponCode: BookingDetails?.CouponCode,
        Amount: BookingDetails?.CouponCodeValue,
        MaxAmount: BookingDetails?.MaxAmount,
        AmountType: BookingDetails?.AmountType,
        Percentage: BookingDetails?.Percentage,
      });
      setAppliedPromoAmount(BookingDetails.CouponCodeValue || 0);
    }
  }, [BookingNo, BookingDetails]);

  // Calculate total number of participants (persons)
  const calculateTotalPersons = (values: any) => {
    const solo = +values?.SoloCount || 0;
    const dual = +values?.DualRiderCount || 0;
    const byob = +values?.BYOBCount || 0;
    const sic = +values?.SICCount || 0;
    const three = +values?.ThreeCount || 0;
    const four = +values?.FourCount || 0;

    const totalPersons = solo + dual + byob + sic + three + four;
    const totalBookings = solo + dual + byob + sic + three + four;

    return {
      totalPersons,
      totalBookings,
    };
  };

  const calculateBaseFareTotal = (values: any) => {
    let baseTotal = 0.0;
    const tourCost = TourCostAndAddonDetails || {};

    // Solo Rider calculation
    const soloCount = parseFloat(values?.SoloCount || 0);
    if (!isNaN(soloCount) && soloCount > 0) {
      baseTotal += soloCount * (+tourCost?.ExtraAdultRate || 0);
    }

    // Dual Rider calculation
    const dualCount = parseFloat(values?.DualRiderCount || 0);
    if (!isNaN(dualCount) && dualCount > 0) {
      baseTotal += dualCount * (+tourCost?.PPRate || 0);
    }

    // BYOB calculation
    const byobCount = parseFloat(values?.BYOBCount || 0);
    if (!isNaN(byobCount) && byobCount > 0) {
      baseTotal += byobCount * (+tourCost?.CWBRate || 0);
    }

    // SIC calculation
    const sicCount = parseFloat(values?.SICCount || 0);
    if (!isNaN(sicCount) && sicCount > 0) {
      baseTotal += sicCount * (+tourCost?.CNBRate || 0);
    }

    // Three calculation
    const threeCount = parseFloat(values?.ThreeCount || 0);
    if (!isNaN(threeCount) && threeCount > 0) {
      baseTotal += threeCount * (+tourCost?.ThreeSharingRate || 0);
    }

    // Four calculation
    const fourCount = parseFloat(values?.FourCount || 0);
    if (!isNaN(fourCount) && fourCount > 0) {
      baseTotal += fourCount * (+tourCost?.FourSharingRate || 0);
    }

    return baseTotal;
  };

  const calculateTotalWithAddons = (values: any) => {
    let total = calculateBaseFareTotal(values);

    // Addons calculation
    TourCostAndAddonDetails?.touraddons?.forEach((addon: any) => {
      const key = `addons_${addon?.ID}`;
      const quantityStr = values[key];
      if (quantityStr) {
        const quantity = parseFloat(quantityStr);
        if (!isNaN(quantity)) {
          total += (+quantity || 0) * (+addon?.Amount || 0);
        }
      }
    });

    return total;
  };

  // Calculate discount PER PERSON for all discount types
  const calculatePromoDiscount = (
    promo: any,
    totalBookings: number,
    baseFareTotal: number,
    values: any,
  ) => {
    if (!promo || totalBookings === 0) return 0;

    let totalDiscount = 0;

    if (promo.AmountType === "PER") {
      // Calculate average booking rate (only on base fare)
      const averageBookingRate = baseFareTotal / totalBookings;

      // Calculate discount per booking first for percentage
      const discountPerBooking =
        (averageBookingRate * (+promo.Percentage || 0)) / 100;
      const totalDiscountFromPercentage = discountPerBooking * totalBookings;

      // Apply max discount limit if exists (total for entire booking)
      if (+promo.MaxAmount > 0) {
        totalDiscount = Math.min(totalDiscountFromPercentage, +promo.MaxAmount);
      } else {
        totalDiscount = totalDiscountFromPercentage;
      }
    } else if (promo.AmountType === "RS") {
      // For fixed amount discount: Apply discount per booking, but cap at booking amount
      const tourCost = TourCostAndAddonDetails || {};

      // Get individual booking amounts
      const soloCount = +values?.SoloCount || 0;
      const dualCount = +values?.DualRiderCount || 0;
      const byobCount = +values?.BYOBCount || 0;
      const sicCount = +values?.SICCount || 0;
      const threeCount = +values?.ThreeCount || 0;
      const fourCount = +values?.FourCount || 0;

      // Get rates
      const soloRate = +tourCost?.ExtraAdultRate || 0;
      const dualRate = +tourCost?.PPRate || 0;
      const byobRate = +tourCost?.CWBRate || 0;
      const sicRate = +tourCost?.CNBRate || 0;
      const threeRate = +tourCost?.ThreeSharingRate || 0;
      const fourRate = +tourCost?.FourSharingRate || 0;

      // Fixed discount amount from promo
      const fixedDiscountAmount = +promo.Amount || 0;

      // Calculate discount for each booking type separately with caps

      // 1. Solo Riders
      for (let i = 0; i < soloCount; i++) {
        const discountForThisSolo = Math.min(fixedDiscountAmount, soloRate);
        totalDiscount += discountForThisSolo;
      }

      // 2. Dual Riders
      for (let i = 0; i < dualCount; i++) {
        const discountForThisDual = Math.min(fixedDiscountAmount, dualRate);
        totalDiscount += discountForThisDual;
      }

      // 3. BYOB Riders
      for (let i = 0; i < byobCount; i++) {
        const discountForThisBYOB = Math.min(fixedDiscountAmount, byobRate);
        totalDiscount += discountForThisBYOB;
      }

      // 4. SIC Riders
      for (let i = 0; i < sicCount; i++) {
        const discountForThisSIC = Math.min(fixedDiscountAmount, sicRate);
        totalDiscount += discountForThisSIC;
      }

      // 5. Three Sharing Riders
      for (let i = 0; i < threeCount; i++) {
        const discountForThisThree = Math.min(fixedDiscountAmount, threeRate);
        totalDiscount += discountForThisThree;
      }

      // 6. Four Sharing Riders
      for (let i = 0; i < fourCount; i++) {
        const discountForThisFour = Math.min(fixedDiscountAmount, fourRate);
        totalDiscount += discountForThisFour;
      }

      // Apply max discount limit if exists (total for entire booking)
      if (+promo.MaxAmount > 0) {
        totalDiscount = Math.min(totalDiscount, +promo.MaxAmount);
      }
    }

    return Math.round(totalDiscount);
  };

  const handleSubmit = async (values: any) => {
    const totalPersons = calculateTotalPersons(values);
    const totalBookings = totalPersons.totalBookings;
    const tourCost = TourCostAndAddonDetails || {};

    if (totalBookings === 0) {
      ErrorToast("Please select at least one participant!");
      return;
    }

    if (totalPersons?.totalBookings > +(values?.AvailableSeat || 0)) {
      ErrorToast(
        `You can not select more than ${+(values?.AvailableSeat || 0)} seats!!!`,
      );
      return;
    }

    setIsProcessing(true);

    let totalAddOns = 0;
    const TourAddons = TourCostAndAddonDetails?.touraddons
      ?.map((addon: any) => {
        const key = `addons_${addon?.ID}`;
        const quantityStr = values[key];
        if (!quantityStr) return null;
        const quantity = parseFloat(quantityStr);
        if (isNaN(quantity) || quantity === 0) return null;

        totalAddOns += (+quantity || 0) * (+addon?.Amount || 0);
        return {
          Title: addon?.Title,
          Quantity: quantity,
          Amount: addon?.Amount,
          ShortDescription: addon?.ShortDescription,
        };
      })
      .filter(Boolean);

    const baseFareTotal = calculateBaseFareTotal(values);
    const grandTotal = calculateTotalWithAddons(values);

    const payload: any = {
      Initial: values?.Initial || "",
      FirstName: values?.FirstName || "",
      LastName: values?.LastName || "",
      EmailID: values?.EmailID || "",
      MobileNo: `${values?.MobileNo}`,
      TravelDate: values?.Date || "",
      AgentName: values?.AgentName || "",
      Remarks: values?.Remarks || "",
      TourID: values?.TourID || "",
      bookingaddons: TourAddons || [],
      TotalPax: totalBookings,
      BasicAmt: +baseFareTotal || 0,
      DiscountAmt: +values?.DiscountAmt || 0,
      TotalAmt: +grandTotal || 0,
      TotalAddOns: totalAddOns || 0,
      CouponCode: appliedPromo?.CouponCode || "",
      CouponCodeValue: appliedPromoAmount || 0,
      FourSharingPax: values?.FourCount ? +values?.FourCount : 0,
      ThreeSharingPax: values?.ThreeCount ? +values?.ThreeCount : 0,
      TwinSharingPax: values?.DualRiderCount ? +values?.DualRiderCount : 0,
      ExtraAdultPax: values?.SoloCount ? +values?.SoloCount : 0,
      CWBPax: values?.BYOBCount ? +values?.BYOBCount : 0,
      CNBPax: values?.SICCount ? +values?.SICCount : 0,
      FourSharingRate:
        values?.FourCount && +values?.FourCount > 0
          ? +tourCost?.FourSharingRate || 0
          : null,
      ThreeSharingRate:
        values?.ThreeCount && +values?.ThreeCount > 0
          ? +tourCost?.ThreeSharingRate || 0
          : null,
      TwinSharingRate:
        values?.DualRiderCount && +values?.DualRiderCount > 0
          ? +tourCost?.PPRate || 0
          : null,
      ExtraAdultRate:
        values?.SoloCount && +values?.SoloCount > 0
          ? +tourCost?.ExtraAdultRate || 0
          : null,
      CWBRate:
        values?.BYOBCount && +values?.BYOBCount > 0
          ? +tourCost?.CWBRate || 0
          : null,
      CNBRate:
        values?.SICCount && +values?.SICCount > 0
          ? +tourCost?.CNBRate || 0
          : null,
      RateID: tourCost?.TourRateID ? +tourCost?.TourRateID : null,
      ...(!BookingNo && {
        PaymentType: values?.PaymentType || "",
        PaymentDate: values?.PaymentDate
          ? moment(values?.PaymentDate).format("YYYY-MM-DD")
          : null,
      }),
      ...(!BookingNo &&
        values?.PaymentType === "Cash" && {
          PaymentAmount: +values?.PaymentAmount || 0,
        }),
      ...(BookingNo && {
        PaymentAmount: +values?.PaymentAmount || 0,
      }),
    };

    let currentPortalBookingNo = "";

    if (BookingNo) {
      payload.ID = values?.ID ? values?.ID : null;
      const lastRes: any = await dispatch(updateTourBooking(payload));
      if (lastRes.meta.requestStatus === "fulfilled") {
        navigate("/booking");
      } else {
        ErrorToast(lastRes?.error?.message || "Failed to update booking.");
        setIsProcessing(false);
        return;
      }
    } else {
      const temres: any = await dispatch(saveTempTourBooking(payload));
      if (
        temres.meta.requestStatus === "rejected" ||
        !temres?.payload?.BookingNo
      ) {
        // throw new Error("Save temp booking failed");
        ErrorToast(
          temres?.error?.message || "Booking failed. Please try again.",
        );
        setIsProcessing(false);
        return;
      }
      currentPortalBookingNo = temres?.payload?.BookingNo || 0;

      if (values?.PaymentType === "Cash") {
        payload.BookingNo = `${currentPortalBookingNo}`;
        await confirmAndProcessBooking(payload);
        setIsProcessing(false);
      } else {
        try {
          if (
            (values?.PayType === "min" && minPaymentAmount > 0) ||
            (values?.PayType === "total" && totalPayable > 0)
          ) {
            const orderResponse: any = await dispatch(
              createPaymentOrder({
                Amount: Math.floor(
                  (values?.PayType === "min"
                    ? minPaymentAmount
                    : values?.PayType === "total"
                      ? totalPayable
                      : 0) * 100,
                ),
                Currency: "INR",
              }),
            );

            const orderDetails = orderResponse?.payload?.Data;
            const options: any = {
              key: RAZORPAY_KEY_ID,
              amount: orderDetails?.Amount,
              currency: orderDetails?.Currency,
              name: "Go 360",
              description: `transction_${currentPortalBookingNo}`,
              order_id: orderDetails?.Orderid,
              modal: {
                ondismiss: function () {
                  setIsProcessing(false);
                },
              },
              handler: async function (response: any) {
                clearTimeout(paymentTimeout);
                const orderDetails: any = await dispatch(
                  verifyPayment({
                    RazorpayOrderId: response.razorpay_order_id,
                    RazorpayPaymentId: response.razorpay_payment_id,
                    RazorpaySignature: response.razorpay_signature,
                    booking_no: currentPortalBookingNo,
                  }),
                );

                if (orderDetails?.meta?.requestStatus === "fulfilled") {
                  payload.BookingNo = `${currentPortalBookingNo}`;
                  await confirmAndProcessBooking(payload);
                } else {
                  console.error("Payment verification failed:", orderDetails);
                }
              },
              theme: {
                color: "#0a9e9f",
              },
            };

            const rzp = new Razorpay(options);
            rzp.open();

            const paymentTimeout = setTimeout(
              () => {
                setIsProcessing(false);
              },
              12 * 60 * 1000,
            );

            rzp.on("payment.failed", function (response: any) {
              clearTimeout(paymentTimeout);
              ErrorToast(`Payment failed: ${response.error.description}`);
              setIsProcessing(false);
              console.error("Payment failed", response);
            });
          } else {
            payload.BookingNo = `${currentPortalBookingNo}`;
            await handleZeroAmountPayment(payload);
          }
        } catch (error) {
          setIsProcessing(false);
          ErrorToast("Booking failed. Please try again.");
          console.error("Booking error:", error);
        }
      }
    }
  };

  const confirmAndProcessBooking = async (payload: any) => {
    const mainPayload = {
      ...payload,
    };

    const lastRes = await dispatch(saveTourBooking(mainPayload));
    if (lastRes.meta.requestStatus === "fulfilled") {
      navigate("/booking");
    }
  };

  const handleZeroAmountPayment = async (values: any) => {
    await confirmAndProcessBooking(values);
  };

  const getOrderedRiderSections = () => {
    const tourCost = TourCostAndAddonDetails || {};

    const allSections = [
      {
        key: "SoloCount",
        sequence: tourCost?.ExtraAdultSequenceNo,
        show: tourCost?.ExtraAdultRate && +tourCost?.ExtraAdultRate > 0,
        title: tourCost?.ExtraAdultTitle || "One Adult",
        description: tourCost?.ExtraAdultDescription || "",
        rate: tourCost?.ExtraAdultRate,
      },
      {
        key: "DualRiderCount",
        sequence: tourCost?.TwinSharingSequenceNo,
        show: tourCost?.PPRate && +tourCost?.PPRate > 0,
        title: tourCost?.TwinSharingTitle || "Twin Sharing",
        description: tourCost?.TwinSharingDescription || "",
        rate: tourCost?.PPRate,
      },
      {
        key: "ThreeCount",
        sequence: tourCost?.ThreeSharingSequenceNo,
        show: tourCost?.ThreeSharingRate && +tourCost?.ThreeSharingRate > 0,
        title: tourCost?.ThreeSharingTitle || "Three Sharing",
        description: tourCost?.ThreeSharingDescription || "",
        rate: tourCost?.ThreeSharingRate,
      },
      {
        key: "FourCount",
        sequence: tourCost?.FourSharingSequenceNo,
        show: tourCost?.FourSharingRate && +tourCost?.FourSharingRate > 0,
        title: tourCost?.FourSharingTitle || "Four Sharing",
        description: tourCost?.FourSharingDescription || "",
        rate: tourCost?.FourSharingRate,
      },
      {
        key: "BYOBCount",
        sequence: tourCost?.CWBSequenceNo,
        show: tourCost?.CWBRate && +tourCost?.CWBRate > 0,
        title: tourCost?.CWBTitle || "Child With Bed",
        description: tourCost?.CWBDescription || "",
        rate: tourCost?.CWBRate,
      },
      {
        key: "SICCount",
        sequence: tourCost?.CNBSequenceNo,
        show: tourCost?.CNBRate && +tourCost?.CNBRate > 0,
        title: tourCost?.CNBTitle || "Child With No Bed",
        description: tourCost?.CNBDescription || "",
        rate: tourCost?.CNBRate,
      },
    ];

    const visibleSections = allSections.filter((section) => section.show);

    return visibleSections.sort((a, b) => {
      const aSeq =
        a.sequence !== null && a.sequence !== undefined ? +a.sequence : 999;
      const bSeq =
        b.sequence !== null && b.sequence !== undefined ? +b.sequence : 999;

      if (aSeq !== bSeq) {
        return aSeq - bSeq;
      }
      return 0;
    });
  };

  const toggleSection = (section: string) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handlePromoCodeApply = async (promo: any) => {
    if (!promo?.trim()) {
      ErrorToast("Please enter a coupon code!");
      return;
    }

    setPromoapplyLoading(true);
    try {
      const res: any = await dispatch(getPromoCodeDetails(promo?.trim()));
      if (res.meta.requestStatus === "fulfilled") {
        setAppliedPromo(res.payload);
        // Calculate discount will be handled in the PaymentSummary component
      } else {
        setAppliedPromo(null);
        setAppliedPromoAmount(0);
        ErrorToast(res?.error?.message || "Invalid coupon code!");
      }
    } catch (error) {
      setAppliedPromo(null);
      setAppliedPromoAmount(0);
      ErrorToast("Failed to apply coupon code!");
    }
    setPromoapplyLoading(false);
  };

  const handlePromoCodeRemove = (formRenderProps: FormRenderProps) => {
    setAppliedPromo(null);
    setAppliedPromoAmount(0);
    formRenderProps.onChange("promoCode", {
      value: "",
    });
  };

  const getAllFormValues = (formRenderProps: FormRenderProps) => {
    // Get all field values by their names
    const values: any = {
      FirstName: formRenderProps.valueGetter("FirstName") || "",
      LastName: formRenderProps.valueGetter("LastName") || "",
      MobileNo: formRenderProps.valueGetter("MobileNo") || "",
      EmailID: formRenderProps.valueGetter("EmailID") || "",
      AgentName: formRenderProps.valueGetter("AgentName") || "",
      TourID: formRenderProps.valueGetter("TourID") || "",
      Date: formRenderProps.valueGetter("Date") || "",
      SoloCount: formRenderProps.valueGetter("SoloCount") || "0",
      DualRiderCount: formRenderProps.valueGetter("DualRiderCount") || "0",
      BYOBCount: formRenderProps.valueGetter("BYOBCount") || "0",
      SICCount: formRenderProps.valueGetter("SICCount") || "0",
      ThreeCount: formRenderProps.valueGetter("ThreeCount") || "0",
      FourCount: formRenderProps.valueGetter("FourCount") || "0",
    };

    // Add addon values
    TourCostAndAddonDetails?.touraddons?.forEach((addon: any) => {
      values[`addons_${addon?.ID}`] =
        formRenderProps.valueGetter(`addons_${addon?.ID}`) || "0";
    });

    return values;
  };

  const PaymentSummaryCard = ({
    formRenderProps,
  }: {
    formRenderProps: FormRenderProps;
  }) => {
    const values = getAllFormValues(formRenderProps);
    const DiscountAmt = +formRenderProps.valueGetter("DiscountAmt") || 0;
    const baseFareTotal = calculateBaseFareTotal(values);
    const grandTotal = calculateTotalWithAddons(values);
    const totalPersons = calculateTotalPersons(values);
    const totalBookings = totalPersons.totalBookings;

    // Recalculate discount when values change
    useEffect(() => {
      if (appliedPromo && totalBookings > 0) {
        const promoAmount = calculatePromoDiscount(
          appliedPromo,
          totalBookings,
          baseFareTotal,
          values,
        );
        setAppliedPromoAmount(promoAmount);
      } else {
        setAppliedPromoAmount(0);
      }
    }, [values, appliedPromo, totalBookings, baseFareTotal]);

    // const totalPayable = grandTotal - appliedPromoAmount;
    setTotalPayable(grandTotal - appliedPromoAmount - DiscountAmt);
    // const minPaymentAmount =
    //   (+TourDetails?.MinPaymentAmount || 0) * totalPersons.totalPersons;
    setMinPaymentAmount(
      (+TourCostAndAddonDetails?.MinPaymentAmount || 0) *
        totalPersons.totalPersons,
    );
    setLastPayableAmount(
      grandTotal - appliedPromoAmount - DiscountAmt >
        (+TourCostAndAddonDetails?.MinPaymentAmount || 0) *
          totalPersons.totalPersons
        ? (+TourCostAndAddonDetails?.MinPaymentAmount || 0) *
            totalPersons.totalPersons
        : grandTotal - appliedPromoAmount - DiscountAmt,
    );
    // const lastPayableAmount =
    //   totalPayable > minPaymentAmount ? minPaymentAmount : totalPayable;

    return (
      <>
        <GridLayout
          style={{ marginRight: 30 }}
          gap={{ rows: 5, cols: 10 }}
          cols={[
            { width: "25%" },
            { width: "25%" },
            { width: "25%" },
            { width: "25%" },
          ]}
        >
          <GridLayoutItem colSpan={4}>
            <Typography.h4 className="typography-head m-0">
              Payment Summary
            </Typography.h4>
          </GridLayoutItem>
          <GridLayoutItem colSpan={4}>
            <div className="space-y-3 mt-2">
              {/* Base Fare Section */}
              <div className="mb-1">
                <div
                  className="d-flex justify-content-between align-items-center cursor-pointer p-2 hover-bg-light rounded"
                  onClick={() => toggleSection("baseFare")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-600">Total Amount</span>
                    {expandedSections.baseFare ? (
                      <IconComponent icon={FiChevronUp} />
                    ) : (
                      <IconComponent icon={FiChevronDown} />
                    )}
                  </div>
                  <span className="fw-600">
                    ₹ {formatIndianNumber(grandTotal)}
                  </span>
                </div>

                {expandedSections.baseFare && (
                  <div className="ps-4 mt-2 border-start border-muted ms-2 pe-2">
                    {getOrderedRiderSections().map((section) => {
                      const count = +values?.[section.key] || 0;
                      if (count === 0) return null;
                      const subtotal = count * (+section.rate || 0);

                      return (
                        <div
                          key={section.key}
                          className="d-flex justify-content-between text-sm mb-1"
                        >
                          <span className="text-muted">
                            {section.title} ({count} × ₹
                            {formatIndianNumber(section.rate || 0)})
                          </span>
                          <span className="text-nowrap">
                            ₹ {formatIndianNumber(subtotal)}
                          </span>
                        </div>
                      );
                    })}

                    {TourCostAndAddonDetails?.touraddons?.map((addon: any) => {
                      const key = `addons_${addon?.ID}`;
                      const quantity = +values?.[key] || 0;
                      if (quantity === 0) return null;
                      const subtotal = quantity * (+addon?.Amount || 0);

                      return (
                        <div
                          key={addon?.ID}
                          className="d-flex justify-content-between text-sm mb-1"
                        >
                          <span className="text-muted">
                            {addon?.Title} ({quantity} × ₹
                            {formatIndianNumber(addon?.Amount || 0)})
                          </span>
                          <span className="text-nowrap">
                            ₹ {formatIndianNumber(subtotal)}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <hr className="my-2" />

              {/* Discount Section */}
              {(appliedPromoAmount > 0 ||
                +formRenderProps.valueGetter("DiscountAmt") > 0) && (
                <div className="mb-3">
                  <div
                    className="d-flex justify-content-between align-items-center cursor-pointer p-2 hover-bg-light rounded"
                    onClick={() => toggleSection("discount")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-600 text-success">
                        Discount Applied
                      </span>

                      {expandedSections.discount ? (
                        <IconComponent icon={FiChevronUp} />
                      ) : (
                        <IconComponent icon={FiChevronDown} />
                      )}
                    </div>
                    <span className="fw-600 text-success">
                      - ₹{" "}
                      {formatIndianNumber(
                        appliedPromoAmount +
                          +(formRenderProps.valueGetter("DiscountAmt") || 0),
                      )}
                    </span>
                  </div>
                  {expandedSections.discount &&
                    +formRenderProps.valueGetter("DiscountAmt") > 0 && (
                      <div className="ps-4 mt-2 border-start border-success ms-2">
                        <div className="d-flex justify-content-between align-items-center text-sm">
                          <div className="d-flex align-items-center gap-2">
                            <span className="text-success">Discount Given</span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <span className="text-success fw-600">
                              - ₹{" "}
                              {formatIndianNumber(
                                +formRenderProps.valueGetter("DiscountAmt") ||
                                  0,
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  {expandedSections.discount && appliedPromo && (
                    <div className="ps-4 mt-2 border-start border-success ms-2">
                      <div className="d-flex justify-content-between align-items-center text-sm">
                        <div className="d-flex align-items-center gap-2">
                          <IconComponent
                            icon={FaCheckCircle}
                            className="text-success"
                          />
                          <span className="text-success">
                            {appliedPromo?.CouponCode}
                            {appliedPromo?.AmountType === "PER" && (
                              <span
                                className="text-muted ms-1"
                                style={{ fontSize: "11px" }}
                              >
                                ({appliedPromo?.Percentage || 0}% off per
                                booking)
                              </span>
                            )}
                          </span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-success fw-600">
                            - ₹ {formatIndianNumber(appliedPromoAmount)}
                          </span>
                          <button
                            className="btn btn-sm btn-outline-danger p-1 d-flex"
                            onClick={() =>
                              handlePromoCodeRemove(formRenderProps)
                            }
                            style={{ width: "24px", height: "24px" }}
                          >
                            <IconComponent icon={RxCross2} />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {appliedPromoAmount > 0 && <hr className="my-2" />}

              {/* Total Payable Amount */}
              <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                <span className="fw-600">Total Payable Amount</span>
                <span className="fw-600 fs-5">
                  ₹ {formatIndianNumber(totalPayable)}
                </span>
              </div>
              {BookingNo &&
              formRenderProps.valueGetter("PaymentAmount") &&
              +formRenderProps.valueGetter("PaymentAmount") > 0 ? (
                <>
                  <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                    <span className="fw-600">Paid Amount</span>
                    <span className="fw-600 fs-5 text-danger">
                      ₹ -
                      {formatIndianNumber(
                        formRenderProps.valueGetter("PaymentAmount") || 0,
                      )}
                    </span>
                  </div>
                  <hr className="my-3" />
                  <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                    <span className="fw-600">Remaining Amount</span>
                    <span className="fw-600 fs-5">
                      ₹{" "}
                      {formatIndianNumber(
                        totalPayable -
                          +formRenderProps.valueGetter("PaymentAmount") || 0,
                      )}
                    </span>
                  </div>
                </>
              ) : null}

              <hr className="my-3" />

              {/* Payable Amount */}
              {!BookingNo && (
                <div className="d-flex justify-content-between px-3 py-2 bg-primary bg-opacity-10 rounded align-items-center">
                  <p className="font-weight-bold mb-0">Min. Payable Amount</p>
                  <p className="font-weight-bold fs-4 text-primary text-right mb-0">
                    ₹ {formatIndianNumber(lastPayableAmount)}
                  </p>
                </div>
              )}
            </div>
          </GridLayoutItem>
        </GridLayout>
      </>
    );
  };

  return (
    <>
      {(loading || isProcessing) && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={BookingDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <TourChangeWatcher formRenderProps={formRenderProps} />
            <DateChangeWatcher formRenderProps={formRenderProps} />
            <TotalBookingWatcher
              formRenderProps={formRenderProps}
              getAllFormValues={getAllFormValues}
              calculateTotalPersons={calculateTotalPersons}
              setTotalBookings={setTotalBookings}
            />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 30 }}
                gap={{ rows: 5, cols: 10 }}
                cols={[
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                ]}
              >
                <GridLayoutItem colSpan={4}>
                  <Typography.h4 className="typography-head m-0">
                    {BookingNo ? "Update Booking" : "Add Booking"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="FirstName"
                    label="First Name"
                    placeholder="i.e.John"
                    maxLength="100"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="LastName"
                    label="Last Name"
                    placeholder="i.e. Smith"
                    maxLength="100"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="MobileNo"
                    label="Mobile No."
                    type="text"
                    maxLength={16}
                    onKeyPress={(e: any) => {
                      const allowedChars = /^[0-9+]$/;
                      if (!allowedChars.test(e?.key)) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="i.e. 9999999999"
                    component={FormTextField}
                    astrike={true}
                    validator={MobileNoValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="EmailID"
                    label="Email ID"
                    astrike={true}
                    placeholder="i.e. example@gmail.com"
                    component={FormTextField}
                    validator={emailValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    id={"TourID"}
                    name={"TourID"}
                    label={"Tour"}
                    placeholder="Tour"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={GroupToursList?.map((tour: ITour) => {
                      return {
                        value: tour?.ID,
                        label: tour?.TourName,
                      };
                    })}
                    onChange={() => {
                      [
                        "SoloCount",
                        "DualRiderCount",
                        "BYOBCount",
                        "SICCount",
                        "ThreeCount",
                        "FourCount",
                        "Date",
                      ]?.map((field: any) => {
                        formRenderProps.onChange(field, { value: "" });
                      });
                      // setSelectedTourDate(null);
                    }}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`Date`}
                    label="Date"
                    placeholder="Date"
                    // format="dd/MM/yyyy"
                    component={FormSelectionField}
                    options={TourDateDetails?.filter((tour: ITourDate) =>
                      moment(tour?.TourDate, "YYYY-MM-DD").isAfter(
                        moment(),
                        "day",
                      ),
                    )?.map((tour: ITourDate) => {
                      return {
                        value: `${moment(tour?.TourDate).format("YYYY-MM-DD")}`,
                        label: `${moment(tour?.TourDate).format("DD/MM/YYYY")}`,
                      };
                    })}
                    onChange={() => {
                      [
                        "SoloCount",
                        "DualRiderCount",
                        "BYOBCount",
                        "SICCount",
                        "ThreeCount",
                        "FourCount",
                      ]?.map((field: any) => {
                        formRenderProps.onChange(field, { value: "" });
                      });
                    }}
                    // onChange={(e: any) => {
                    //   if (e?.value) {
                    //     const selectedDate: any = TourDateDetails?.find(
                    //       (tour) =>
                    //         moment(tour?.TourDate).isSame(moment(e?.value)),
                    //     );
                    //     // if (selectedDate) {
                    //     //   setSelectedTourDate(selectedDate);
                    //     // }
                    //   }
                    //   // else {
                    //   //   setSelectedTourDate(null);
                    //   // }
                    // }}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="AgentName"
                    label="Agent Name"
                    placeholder="i.e.John"
                    maxLength="100"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 12, marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 10, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head m-0 d-flex justify-content-between gap-1 w-100">
                    How Many Participants?
                    {formRenderProps.valueGetter("RealAvailableSeat") ||
                    formRenderProps.valueGetter("RealAvailableSeat") === 0 ? (
                      <div className="fs-6 mb-0">
                        Available Seat :{" "}
                        <span className="fs-5 text-success">
                          {formRenderProps.valueGetter("RealAvailableSeat") ||
                            0}
                        </span>
                      </div>
                    ) : null}
                  </Typography.h4>
                </GridLayoutItem>
                {getOrderedRiderSections()?.map((section: any) => (
                  <>
                    <GridLayoutItem
                      colSpan={2}
                      className="d-flex flex-column justify-content-center"
                    >
                      <p className="mb-0 fw-500 fs-6">{section?.title}</p>
                      {section?.description && (
                        <p className="mb-0" style={{ fontSize: 12 }}>
                          {section?.description}
                        </p>
                      )}
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        id={"TourID"}
                        name={`${section?.key}`}
                        label={""}
                        placeholder="0"
                        wrapperClassName="m-0"
                        component={FormSelectionField}
                        // validator={requiredValidator}
                        // astrike={true}
                        options={AdultOption?.map((option: any) => {
                          return {
                            value: option?.value,
                            label: `${option?.label} ${
                              option?.value > 0
                                ? `x ${formatIndianNumber(section?.rate || 0)}/-`
                                : ""
                            }`,
                          };
                        })}
                      />
                    </GridLayoutItem>
                  </>
                ))}
              </GridLayout>
            </ShadowCard>
            {TourCostAndAddonDetails?.touraddons &&
              TourCostAndAddonDetails?.touraddons?.length > 0 && (
                <ShadowCard style={{ padding: 12, marginTop: 10 }}>
                  <GridLayout
                    style={{ marginRight: 20 }}
                    gap={{ rows: 10, cols: 10 }}
                    cols={[
                      { width: "33.33%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem colSpan={3}>
                      <Typography.h4 className="typography-head m-0">
                        Optional Addons
                      </Typography.h4>
                    </GridLayoutItem>
                    {TourCostAndAddonDetails?.touraddons?.map((addons: any) => (
                      <>
                        <GridLayoutItem
                          colSpan={2}
                          className="d-flex flex-column justify-content-center"
                        >
                          <p className="mb-0 fw-500 fs-6">{addons?.Title}</p>
                          <p className="mb-0" style={{ fontSize: 12 }}>
                            {addons?.ShortDescription}
                          </p>
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            id={"TourID"}
                            name={`addons_${addons?.ID}`}
                            label={""}
                            placeholder="0"
                            wrapperClassName="m-0"
                            component={FormSelectionField}
                            // validator={requiredValidator}
                            // astrike={true}
                            options={AddonOption?.map((option: any) => {
                              return {
                                value: option?.value,
                                label: `${option?.label} ${
                                  option?.value > 0
                                    ? `x ${formatIndianNumber(addons?.Amount || 0)}/-`
                                    : ""
                                }`,
                              };
                            })}
                          />
                        </GridLayoutItem>
                      </>
                    ))}
                    {/* <GridLayoutItem
                  colSpan={3}
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={BookingID ? "Update" : "Save"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />

                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => navigate("/booking")}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem> */}
                  </GridLayout>
                </ShadowCard>
              )}
            <ShadowCard
              style={{ padding: 12, marginTop: 10, marginBottom: 50 }}
            >
              <GridLayout
                style={{ marginRight: 30 }}
                gap={{ rows: 5, cols: 10 }}
                cols={[
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                ]}
              >
                <GridLayoutItem colSpan={4}>
                  <PaymentSummaryCard formRenderProps={formRenderProps} />
                </GridLayoutItem>
                {/* Promo Code Section */}
                <GridLayoutItem className="mt-3">
                  <div className="">
                    <label className="form-label fw-600 d-flex align-items-center gap-2 m-0">
                      <IconComponent icon={IoPricetagsSharp} />
                      Apply Coupon Code
                    </label>
                    <div className="d-flex gap-2">
                      <div className="flex-fill position-relative">
                        <Field
                          wrapperClassName="m-0"
                          name="promoCode"
                          label=""
                          placeholder="Coupon Code"
                          maxLength="100"
                          component={FormTextField}
                          // value={promoCodeInput}
                          // onChange={(e) => setPromoCodeInput(e.target.value)}
                          onKeyDown={(
                            e: React.KeyboardEvent<HTMLInputElement>,
                          ) => {
                            if (e.key === "Enter" || e.key === "Tab") {
                              e.preventDefault();
                              if ((e.target as HTMLInputElement).value) {
                                handlePromoCodeApply(
                                  (e.target as HTMLInputElement).value,
                                );
                              }
                            }
                          }}
                          disabled={promoapplyLoading}
                        />
                        {promoapplyLoading && (
                          <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                            <div
                              className="spinner-border spinner-border-sm text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        )}
                        {appliedPromo?.CouponCode && !promoapplyLoading && (
                          <div className="position-absolute end-0 top-50 translate-middle-y me-3">
                            <IconComponent
                              icon={FaCheckCircle}
                              className="text-success"
                            />
                          </div>
                        )}
                      </div>
                      {(!appliedPromo ||
                        appliedPromo.CouponCode?.toLowerCase() !==
                          formRenderProps
                            .valueGetter("promoCode")
                            ?.toLowerCase()) && (
                        <Button
                          themeColor={"primary"}
                          fillMode={"solid"}
                          type="button"
                          onClick={() =>
                            handlePromoCodeApply(
                              formRenderProps.valueGetter("promoCode"),
                            )
                          }
                          disabled={
                            promoapplyLoading ||
                            !formRenderProps.valueGetter("promoCode")?.trim()
                          }
                        >
                          {promoapplyLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              ></span>
                              Applying...
                            </>
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </div>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100 right-aligned-field mt-3"
                    name="DiscountAmt"
                    label="Discount Amount"
                    placeholder="0"
                    min={0}
                    max={totalPayable || 0}
                    component={FormNumericTextField}
                  />
                </GridLayoutItem>
                {BookingNo && (
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="w-100 right-aligned-field mt-3"
                      name="PaymentAmount"
                      label="Paid Amount"
                      placeholder="0"
                      max={totalPayable || 0}
                      component={FormNumericTextField}
                    />
                  </GridLayoutItem>
                )}
                {!BookingNo && (
                  <>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="mt-3"
                        name="PaymentType"
                        label="Payment Mode"
                        placeholder="i.e.Bank Trasnfer"
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        options={PAYMENT_MODE?.map((pay: any) => {
                          return {
                            value: pay?.value,
                            label: pay?.label,
                          };
                        })}
                        onChange={() => {
                          formRenderProps.onChange("PaymentAmount", {
                            value: "0",
                          });
                          formRenderProps.onChange("PaymentDate", {
                            value: "",
                          });
                        }}
                      />
                    </GridLayoutItem>
                    {formRenderProps.valueGetter("PaymentType") === "Cash" && (
                      <GridLayoutItem>
                        <Field
                          wrapperClassName="w-100 right-aligned-field mt-3"
                          name="PaymentAmount"
                          label="Cash Amount"
                          placeholder="0"
                          max={totalPayable || 0}
                          component={FormNumericTextField}
                          onChange={(e: any) => {
                            if (!e?.value || (e?.value && +e?.value < 1)) {
                              formRenderProps.onChange("PaymentDate", {
                                value: "",
                              });
                            }
                          }}
                        />
                      </GridLayoutItem>
                    )}
                    {+formRenderProps.valueGetter("PaymentAmount") > 0 && (
                      <GridLayoutItem>
                        <Field
                          id={"PaymentDate"}
                          name={"PaymentDate"}
                          component={FormDatePicker}
                          label={"PaymentDate"}
                          validator={requiredValidator}
                          maxDate={moment().toDate()}
                          astrike={true}
                        />
                      </GridLayoutItem>
                    )}
                  </>
                )}
                <GridLayoutItem colSpan={4}>
                  <Field
                    name="Remarks"
                    label="Remarks"
                    placeholder="Remarks"
                    component={FormTextArea}
                    rows={3}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={4}>
                  <div className="d-flex justify-content-end">
                    <div className="text-end" style={{ marginTop: 35 }}>
                      {BookingNo ? (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          style={{ marginLeft: 10 }}
                          onClick={(e) => {
                            e.preventDefault();
                            formRenderProps.onSubmit(e);
                          }}
                          disabled={isProcessing || totalBookings === 0}
                        >
                          Save
                        </Button>
                      ) : formRenderProps.valueGetter("PaymentType") ===
                        "Cash" ? (
                        <Button
                          type="button"
                          fillMode={"solid"}
                          themeColor={"primary"}
                          style={{ marginLeft: 10 }}
                          onClick={(e) => {
                            e.preventDefault();
                            formRenderProps.onChange("PayType", {
                              value: "cash",
                            });
                            formRenderProps.onSubmit(e);
                          }}
                          disabled={isProcessing || totalBookings === 0}
                        >
                          Save
                        </Button>
                      ) : (
                        <>
                          {minPaymentAmount < totalPayable && (
                            <Button
                              type="button"
                              fillMode={"solid"}
                              themeColor={"info"}
                              style={{ marginLeft: 10 }}
                              onClick={(e) => {
                                e.preventDefault();
                                formRenderProps.onChange("PayType", {
                                  value: "min",
                                });
                                formRenderProps.onSubmit(e);
                              }}
                              disabled={isProcessing || totalBookings === 0}
                            >
                              Proceed to Minimum Pay ₹
                              {formatIndianNumber(minPaymentAmount || 0)}
                            </Button>
                          )}
                          <Button
                            type="button"
                            fillMode={"solid"}
                            themeColor={"primary"}
                            style={{ marginLeft: 10 }}
                            onClick={(e) => {
                              e.preventDefault();
                              formRenderProps.onChange("PayType", {
                                value: "total",
                              });
                              formRenderProps.onSubmit(e);
                            }}
                            disabled={isProcessing || totalBookings === 0}
                          >
                            Proceed to Total Pay ₹
                            {formatIndianNumber(totalPayable || 0)}
                          </Button>
                        </>
                      )}

                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 10 }}
                        onClick={() => navigate("/booking")}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                  {/* <button
              className="btn btn-primary w-100 py-3 fs-5 mt-4"
              type="submit"
              disabled={isProcessing || totalBookings === 0}
              onClick={(e) => {
                e.preventDefault();
                formRenderProps.onSubmit(e);
              }}
            >
              {isProcessing ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Processing...
                </>
              ) : (
                `Proceed to Pay ₹${formatIndianNumber(lastPayableAmount || 0)}`
              )}
            </button> */}
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateBooking;
